import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function CGV() {
  return (
    <div className="min-h-screen bg-[#f8faff] text-[#1a2332] font-body">
      <Seo title="Conditions générales de vente | DDSBillancourt" path="/cgv" />
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-2 text-[#5b6577] hover:text-[#00a86b] text-sm font-headings font-semibold mb-8" data-testid="cgv-back">
          <ArrowLeft className="w-4 h-4" /> Retour à l'accueil
        </Link>
        <h1 className="font-headings font-black text-4xl md:text-5xl tracking-tight">Conditions Générales de Vente</h1>

        <div className="mt-10 space-y-8">
          <S title="Article 1 — Objet">
            Les présentes Conditions Générales de Vente régissent les relations entre DDSEmpire — Dynastie Drive School (ci-après « l'auto-école ») et tout élève (ci-après « l'élève ») souscrivant à une formation au permis de conduire ou à la plateforme e-learning.
          </S>
          <S title="Article 2 — Inscription">
            L'inscription est effective à la signature du contrat de formation et au versement d'un acompte. Documents requis : pièce d'identité, justificatif de domicile, photo d'identité, ASSR2 (le cas échéant), attestation d'hébergement si nécessaire.
          </S>
          <S title="Article 3 — Tarifs et formules">
            Les tarifs en vigueur sont ceux affichés sur le site ddsbillancourt.fr et dans le contrat de formation. Tarifs de lancement actuels : 20 leçons à 999 € (au lieu de 1 149 €), 30 leçons à 1 349 € (au lieu de 1 695 €). L'heure de conduite supplémentaire est facturée 45 €. La plateforme e-learning seule est à 10 €.
          </S>
          <S title="Article 4 — Modalités de paiement">
            Paiement comptant à l'inscription ou en 3 fois sans frais. Moyens acceptés : espèces, carte bancaire, virement. Aucun escompte pour paiement anticipé.
          </S>
          <S title="Article 5 — Déroulement des cours">
            Chaque séance dure 1 heure (55 minutes de conduite + 5 minutes de bilan). Plages de conduite : du lundi au samedi de 7h à 22h, le dimanche de 10h à 20h. Horaires de bureau : du lundi au vendredi de 10h à 21h, le samedi de 10h à 18h30. L'élève peut être accompagné par plusieurs moniteurs au cours de sa formation, avec un moniteur référent désigné. Les leçons de conduite programmées entre 20h et 22h font l'objet d'une majoration de 5 € par heure, applicable au tarif horaire du pack souscrit.
          </S>
          <S title="Article 6 — Annulation et report">
            Toute annulation de leçon doit être effectuée au moins 24 heures à l'avance. À défaut, la leçon est due. Les leçons non réalisées du fait de l'auto-école sont reportées sans frais.
          </S>
          <S title="Article 7 — Présentation à l'examen">
            La présentation à l'examen pratique est conditionnée à la validation des 4 compétences du REMC. L'auto-école ne garantit pas le succès à l'examen, qui dépend de l'évaluation indépendante de l'inspecteur du permis de conduire.
          </S>
          <S title="Article 8 — Plateforme e-learning">
            L'accès à la plateforme est nominatif et non transférable. Tout partage de compte entraîne sa suspension immédiate. Le système de verrou d'appareil (device fingerprint) protège votre compte ; un déblocage est possible auprès de votre moniteur ou administrateur.
          </S>
          <S title="Article 9 — Jeu Concours Légende">
            Le jeu concours est ouvert aux élèves ayant atteint le niveau Légende dans la plateforme e-learning, sous réserve de 10 heures de formation pratique minimum et de 50 participants au concours. Lots : iPhone (1er), Lunettes Meta (2ème), AirPods (3ème). Règlement complet disponible sur demande.
          </S>
          <S title="Article 10 — Résiliation">
            En cas d'arrêt anticipé de la formation à l'initiative de l'élève, les leçons déjà effectuées sont facturées au tarif unitaire de 45 €. Le solde, déduction faite des frais d'inscription forfaitaires, est remboursé sous 30 jours.
          </S>
          <S title="Article 11 — Médiation et litiges">
            Tout litige est soumis au droit français. Avant toute action judiciaire, l'élève peut saisir gratuitement un médiateur de la consommation conformément à l'article L612-1 du Code de la consommation.
          </S>
        </div>

        <div className="mt-14 pt-8 border-t border-black/10 text-xs text-[#5b6577]">
          Dernière mise à jour : 23 avril 2026 · DDSEmpire — Dynastie Drive School
        </div>
      </div>
    </div>
  );
}

function S({ title, children }) {
  return (
    <section>
      <h2 className="font-headings font-black text-xl md:text-2xl text-[#1a2332] mb-2">{title}</h2>
      <p className="text-[#3a4858] leading-relaxed">{children}</p>
    </section>
  );
}
